module.exports = __webpack_public_path__ + "static/img/changjianwenti.479d6c15.png";